var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tab-vessel-eq", attrs: { id: "tabVesselEq" } },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.showBookingEdi1 && _vm.showButton) ||
                        !_vm.readonly,
                      expression: "(showBookingEdi1 && showButton) || !readonly"
                    }
                  ],
                  staticClass: "section"
                },
                [
                  _c("div", { staticClass: "operations" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-menu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showBookingEdi1 && _vm.showButton,
                                    expression: "showBookingEdi1 && showButton"
                                  }
                                ],
                                staticClass:
                                  "el-menu-button el-button el-button--primary el-button--mini",
                                staticStyle: {
                                  width: "90px",
                                  "vertical-align": "top"
                                },
                                attrs: {
                                  "text-color": "#404144",
                                  "active-text-color": "#404144",
                                  mode: "horizontal"
                                },
                                on: { select: _vm.toBooking }
                              },
                              [
                                _c(
                                  "el-submenu",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.bookingEdi1Disabled ||
                                        !(
                                          _vm.action === "look" && _vm.form.uuid
                                        ),
                                      index: "index"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-menu-btn-text",
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.EDIBooking"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "original" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Original"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API0",
                                              disabled: !_vm.bookingEDIApiOpen
                                            }
                                          },
                                          [_vm._v("API")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          { attrs: { index: "FTP1" } },
                                          [_vm._v("FTP")]
                                        )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "correct" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Correct"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          { attrs: { index: "FTP0" } },
                                          [_vm._v("FTP")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API1",
                                              disabled: !_vm.bookingEDIApiOpen
                                            }
                                          },
                                          [_vm._v("API")]
                                        )
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "shutOut" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.ShutOut"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          { attrs: { index: "FTP2" } },
                                          [_vm._v("FTP")]
                                        ),
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "API2",
                                              disabled: true
                                            }
                                          },
                                          [_vm._v("API")]
                                        )
                                      ],
                                      2
                                    ),
                                    _vm.seAllowReceiptImport
                                      ? _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: _vm.$t(
                                                "SeaExport.ReceiptImport"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.ReceiptImport"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "can-operate",
                                attrs: { no: "1", type: "primary" },
                                on: { click: _vm.loadBookingLog }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BookingLog"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_SEBooking_Subscription"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_SEBooking_Subscription'])"
                                  }
                                ],
                                staticClass: "can-operate",
                                attrs: {
                                  no: "bookingSubscribe",
                                  type: "primary"
                                },
                                on: { click: _vm.subscribeSeaBooking }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BookingSubscribe")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_SEBooking_Subscription"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_SEBooking_Subscription'])"
                                  }
                                ],
                                staticClass: "can-operate",
                                attrs: {
                                  no: "bookingSubscribeSync",
                                  type: "primary"
                                },
                                on: { click: _vm.subscribeSeaBookingSync }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_BookingSubscribeSync"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_SEBooking_Subscription"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_SEBooking_Subscription'])"
                                  }
                                ],
                                staticClass: "can-operate",
                                attrs: {
                                  no: "bookingSubscriptionStatus",
                                  type: "primary"
                                },
                                on: { click: _vm.openSubscriptionStatusDialog }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_BookingSubscriptionStatus"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.readonly &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "!readonly && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateMBL"],
                                    expression:
                                      "['button_SEBooking_generateMBL']"
                                  }
                                ],
                                attrs: { no: "2", type: "primary" },
                                on: { click: _vm.generateMblNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.GeneratePrimaryDocNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.readonly &&
                                      _vm.form.mbl &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "!readonly && form.mbl && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateSoNo"],
                                    expression:
                                      "['button_SEBooking_generateSoNo']"
                                  }
                                ],
                                attrs: { no: "3", type: "primary" },
                                on: { click: _vm.generateSoNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.AddSpellCustomsOrderNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.readonly &&
                                      _vm.form.mbl &&
                                      _vm.form.masterFlag &&
                                      [1, 2, 3].includes(_vm.isInputMbl),
                                    expression:
                                      "readonly && form.mbl && form.masterFlag && [1, 2, 3].includes(isInputMbl)"
                                  },
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_SEBooking_generateMBL"],
                                    expression:
                                      "['button_SEBooking_generateMBL']"
                                  }
                                ],
                                attrs: { no: "4", type: "primary" },
                                on: { click: _vm.allocateSoNo }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.DistributionCustomsNo")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.enableShipperConsignNotify,
                                    expression: "enableShipperConsignNotify"
                                  }
                                ],
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "shipperLock",
                                  disabled: _vm.enableShipperLock
                                },
                                model: {
                                  value: _vm.form.shipperLock,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperLock", $$v)
                                  },
                                  expression: "form.shipperLock"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ShipperLocked"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { "padding-left": "0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.uuid &&
                            _vm.showResubscribeBookingReceipt &&
                            _vm.canSubscribeReceipt &&
                            [
                              _vm.SystemConstants
                                .JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code,
                              _vm.SystemConstants
                                .JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code
                            ].indexOf(_vm.form.bookingState) > -1,
                          expression:
                            "form.uuid && showResubscribeBookingReceipt && canSubscribeReceipt && [SystemConstants.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code, SystemConstants.JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code].indexOf(form.bookingState) > -1"
                        }
                      ],
                      attrs: {
                        no: "resubscribeBookingReceipt",
                        type: "primary"
                      },
                      on: { click: _vm.subscribeReceiptExec }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ResubscribeBookingReceipt")
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "tab-vessel-eq-UICustom-layout",
            { attrs: { "element-blocks": _vm.elementBlocks } },
            [
              _vm.elementDict.vesselAndVoyage &&
              _vm.elementDict.vesselAndVoyage.viewable &&
              _vm.showVessel
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "vesselAndVoyage" },
                      slot: "vesselAndVoyage"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.vesselAndVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vesselAndVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.vesselAndVoyage
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "vesselAndVoyage",
                          disabled:
                            _vm.readonlyVessel ||
                            !_vm.elementDict.vesselAndVoyage.writable
                        },
                        on: {
                          input: function(value) {
                            return _vm.pm.onVesselAndVoyageChange(value)
                          }
                        },
                        model: {
                          value: _vm.form.vesselAndVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vesselAndVoyage", $$v)
                          },
                          expression: "form.vesselAndVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.vessel && _vm.elementDict.vessel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "vessel" }, slot: "vessel" },
                    [
                      _c("line-label", {
                        class: _vm.fieldClass.vesselTitle
                          ? _vm.fieldClass.vesselTitle
                          : _vm.elementDict.vessel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vessel.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.vessel
                          ? _vm.fieldClass.vessel + " red-border"
                          : _vm.fieldClass.vessel,
                        attrs: {
                          no: "5",
                          disabled:
                            !_vm.pm.lclslaveEnabledExcludeExportToImport ||
                            !_vm.elementDict.vessel.writable,
                          "select-type": _vm.selectTypeNames.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "allow-create": _vm.pm._allowEditingVessel,
                          "default-value": _vm.form.vessel,
                          "static-options": _vm.pm.vesselList,
                          "latest-used-data-key":
                            _vm.elementDict.vessel.userCustomContent &&
                            _vm.elementDict.vessel.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-vessel"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.onVesselSelectionChange(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.voyageFlight &&
                        _vm.elementDict.voyageFlight.viewable,
                      expression:
                        "elementDict.voyageFlight && elementDict.voyageFlight.viewable"
                    }
                  ],
                  attrs: { slot: "voyageFlight" },
                  slot: "voyageFlight"
                },
                [
                  _c("line-label", {
                    class: _vm.fieldClass.voyageFlightTitle
                      ? _vm.fieldClass.voyageFlightTitle
                      : _vm.elementDict.voyageFlight.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        class: _vm.importDifferenceField.voyageFlight
                          ? _vm.fieldClass.voyageFlight + " red-border"
                          : _vm.fieldClass.voyageFlight,
                        attrs: {
                          no: "6",
                          "static-options": _vm.pm._voyages || [],
                          cache: false,
                          "default-value": _vm.form.voyageFlight,
                          disabled:
                            !_vm.pm.lclslaveEnabledExcludeExportToImport ||
                            !_vm.elementDict.voyageFlight.writable,
                          filterable: "",
                          clearable: "",
                          "allow-create": _vm.pm.editVoyageMode === 1,
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "filter-tag-names": ["voyageNo"],
                          "latest-used-data-key":
                            _vm.elementDict.voyageFlight.userCustomContent &&
                            _vm.elementDict.voyageFlight.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-voyageFlight"
                              : ""
                        },
                        on: {
                          focus: function($event) {
                            return _vm.pm.txtVoyageFocusInHandler()
                          },
                          parentCallBack: function(p) {
                            _vm.pm.onVoyageFlightChange(p)
                          }
                        }
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isSelectVesselSchedule &&
                                _vm.action !== "look",
                              expression:
                                "isSelectVesselSchedule && action !== 'look'"
                            }
                          ],
                          staticClass:
                            "el-button el-button--primary el-button--mini",
                          staticStyle: {
                            "min-width": "40px!important",
                            "margin-left": "2px"
                          },
                          on: { click: _vm.btnVayageShowHandle }
                        },
                        [_c("i", { staticClass: "el-icon-search" })]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.carrierVoyage &&
              _vm.elementDict.carrierVoyage.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "carrierVoyage" }, slot: "carrierVoyage" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.carrierVoyage
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.canEditInternalDelegatedJobField ||
                            !_vm.elementDict.carrierVoyage.writable,
                          no: "carrierVoyage"
                        },
                        model: {
                          value: _vm.form.carrierVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "carrierVoyage", $$v)
                          },
                          expression: "form.carrierVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.soNo && _vm.elementDict.soNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "soNo" }, slot: "soNo" },
                    [
                      _c("line-label", {
                        class: _vm.fieldClass.soNoTitle
                          ? _vm.fieldClass.soNoTitle
                          : _vm.elementDict.soNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.soNo.label
                        },
                        slot: "label"
                      }),
                      _c("so-no-input", {
                        class: _vm.fieldClass.soNo,
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.slaveCustomsDeclarationEnable ||
                            !_vm.elementDict.soNo.writable
                        },
                        on: {
                          blur: function($event) {
                            return _vm.mblBlur(_vm.form.soNo, true)
                          }
                        },
                        model: {
                          value: _vm.form.soNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "soNo", $$v)
                          },
                          expression: "form.soNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mbl && _vm.elementDict.mbl.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "mbl" }, slot: "mbl" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.mbl.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "padding-right": "3px"
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: [0, 2, 3].includes(_vm.isInputMbl),
                                expression: "[0, 2, 3].includes(isInputMbl)"
                              }
                            ],
                            class:
                              _vm.form.mbl === "CANCELLED" ? "mbl-red" : "",
                            attrs: {
                              no: "7",
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.mbl.writable
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.changeMbl()
                              },
                              blur: function($event) {
                                return _vm.mblBlur(_vm.form.mbl, false)
                              }
                            },
                            model: {
                              value: _vm.form.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mbl", $$v)
                              },
                              expression: "form.mbl"
                            }
                          }),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: [1].includes(_vm.isInputMbl),
                                expression: "[1].includes(isInputMbl)"
                              }
                            ],
                            class:
                              _vm.form.mbl === "CANCELLED" ? "mbl-red" : "",
                            attrs: {
                              no: "8",
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.mblEditable ||
                                !_vm.elementDict.mbl.writable
                            },
                            on: {
                              input: function($event) {
                                _vm.mblConfig.curRule = null
                              },
                              change: function($event) {
                                return _vm.pm.changeMbl()
                              },
                              blur: function($event) {
                                return _vm.mblBlur(_vm.form.mbl, false)
                              }
                            },
                            model: {
                              value: _vm.form.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mbl", $$v)
                              },
                              expression: "form.mbl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingNo && _vm.elementDict.bookingNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingNo" }, slot: "bookingNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bookingNo.writable,
                          no: "9"
                        },
                        model: {
                          value: _vm.form.bookingNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bookingNo", $$v)
                          },
                          expression: "form.bookingNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.stationCode &&
              _vm.elementDict.stationCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "stationCode" }, slot: "stationCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.stationCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.stationCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "10",
                            filterable: "",
                            clearable: "",
                            disabled:
                              _vm.readonlyExcludeExportToImport ||
                              !_vm.elementDict.stationCode.writable,
                            placeholder: _vm.$t("common.defaultPlaceholder")
                          },
                          model: {
                            value: _vm.form.stationCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "stationCode", $$v)
                            },
                            expression: "form.stationCode"
                          }
                        },
                        _vm._l(_vm.stationOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: {
                              label: item.label + "(" + item.value + ")",
                              value: item.value
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.scNo && _vm.elementDict.scNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "scNo" }, slot: "scNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.scNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.scNo.label
                        },
                        slot: "label"
                      }),
                      _vm.sCNumberSelectMethod === 0
                        ? _c("el-input", {
                            style: _vm.isTP
                              ? "width: 75%;display: inline-block"
                              : "",
                            attrs: {
                              no: "10",
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.scNo.writable,
                              placeholder: _vm.$t("common.defaultPlaceholder")
                            },
                            model: {
                              value: _vm.form.scNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "scNo", $$v)
                              },
                              expression: "form.scNo"
                            }
                          })
                        : _vm.sCNumberSelectMethod === 1
                        ? _c("cargo-advance-select", {
                            ref: "scNoSelect",
                            style: _vm.isTP
                              ? "width: 75%;display: inline-block"
                              : "",
                            attrs: {
                              no: "10",
                              filterable: "",
                              "allow-create": false,
                              "select-type":
                                _vm.selectTypeNames.basic_data_ShippingContract,
                              "static-options": _vm.shippingContractList,
                              "tag-value": "contractNumber",
                              "default-value": _vm.form.scNo,
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.scNo.writable,
                              placeholder: _vm.$t("common.defaultPlaceholder")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.onscNoChange(p)
                              }
                            }
                          })
                        : _c("cargo-advance-select", {
                            ref: "scNoSelect",
                            style: _vm.isTP
                              ? "width: 75%;display: inline-block"
                              : "",
                            attrs: {
                              no: "10",
                              filterable: "",
                              "allow-create": true,
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.scNo.writable,
                              "select-type":
                                _vm.selectTypeNames.basic_data_ShippingContract,
                              "static-options": _vm.shippingContractList,
                              "tag-value": "contractNumber",
                              "default-value": _vm.form.scNo,
                              placeholder: _vm.$t("common.defaultPlaceholder")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.onscNoChange(p)
                              }
                            }
                          }),
                      _vm.isTP
                        ? _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "25%",
                                display: "inline-block"
                              },
                              attrs: {
                                disabled:
                                  _vm.readonlyExcludeExportToImport ||
                                  !_vm.elementDict.scNo.writable,
                                no: "flashPointUnit",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.form.scNoType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "scNoType", $$v)
                                },
                                expression: "form.scNoType"
                              }
                            },
                            _vm._l(_vm.scNoTypeArray, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.contractNo &&
                        _vm.elementDict.contractNo.viewable,
                      expression:
                        "elementDict.contractNo && elementDict.contractNo.viewable"
                    }
                  ],
                  attrs: { slot: "contractNo" },
                  slot: "contractNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contractNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contractNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "contractNo",
                    class: _vm.importDifferenceField.contractNo
                      ? _vm.fieldClass.contractNo + " red-border"
                      : _vm.fieldClass.contractNo,
                    attrs: {
                      no: "11",
                      "static-options": _vm.availableContractNos,
                      cache: false,
                      "default-value": _vm.form.contractNo,
                      disabled:
                        _vm.readonlyExcludeExportToImport ||
                        !_vm.pm.lclslaveEnabledExcludeExportToImport ||
                        !_vm.elementDict.contractNo.writable,
                      filterable: "",
                      clearable: "",
                      "allow-create": true,
                      "tag-name": "contractNo",
                      "tag-value": "contractNo",
                      "filter-tag-names": ["contractNo"]
                    },
                    on: { parentCallBack: _vm.onContractNoChange }
                  })
                ],
                1
              ),
              _vm.elementDict.quotationNum &&
              _vm.elementDict.quotationNum.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "quotationNum" }, slot: "quotationNum" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quotationNum.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quotationNum.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.quotationNum
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.quotationNum.writable,
                          no: "12"
                        },
                        model: {
                          value: _vm.form.quotationNum,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quotationNum", $$v)
                          },
                          expression: "form.quotationNum"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.vesselIMO && _vm.elementDict.vesselIMO.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "vesselIMO" }, slot: "vesselIMO" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.vesselIMO.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vesselIMO.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.vesselIMO
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.vesselIMO.writable,
                          no: "13"
                        },
                        model: {
                          value: _vm.form.vesselIMO,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vesselIMO", $$v)
                          },
                          expression: "form.vesselIMO"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierCode &&
              _vm.elementDict.carrierCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "carrierCode" }, slot: "carrierCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.carrierCode
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled: _vm.readonlyExcludeExportToImport,
                          no: "carrierCode"
                        },
                        model: {
                          value: _vm.form.carrierCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "carrierCode", $$v)
                          },
                          expression: "form.carrierCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.vesselCode && _vm.elementDict.vesselCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "vesselCode" }, slot: "vesselCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.vesselCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vesselCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.vesselCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "14",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.pm.lclslaveEnabledExcludeExportToImport ||
                            !_vm.elementDict.vesselCode.writable
                        },
                        model: {
                          value: _vm.form.vesselCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vesselCode", $$v)
                          },
                          expression: "form.vesselCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.routeCode && _vm.elementDict.routeCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "routeCode" }, slot: "routeCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.routeCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.routeCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.routeCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "95",
                          disabled:
                            _vm.checkRouteCode ||
                            _vm.readonly ||
                            !_vm.pm.lclslaveEnabledExcludeExportToImport ||
                            !_vm.elementDict.routeCode.writable
                        },
                        model: {
                          value: _vm.form.routeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "routeCode", $$v)
                          },
                          expression: "form.routeCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cNptNo && _vm.elementDict.cNptNo.viewable
                ? _c(
                    "template",
                    { slot: "cNptNo" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cNptNo.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cNptNo.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-repeat-value-select", {
                            attrs: {
                              placeholder: "",
                              no: "cNptNo",
                              filterable: "",
                              "allow-create": true,
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.cNptNo.writable,
                              clearable: "",
                              options: _vm.cNptList,
                              "label-field": "no",
                              "value-field": "no",
                              "unique-field": "no",
                              "match-of-repeat-value": _vm.matchOfCNpt
                            },
                            on: {
                              change: _vm.cNptChangeHandler,
                              handleBlur: _vm.cNptBlurHandler
                            },
                            model: {
                              value: _vm.form.cNptNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cNptNo", $$v)
                              },
                              expression: "form.cNptNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.cNptNo.writable,
                              no: "cNptName",
                              type: "textarea",
                              rows: 3
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAdvanceTextDialog(
                                  "",
                                  _vm.form.cNptName,
                                  function(val) {
                                    _vm.form.cNptName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cNptName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cNptName", $$v)
                              },
                              expression: "form.cNptName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerReserveVoyage &&
              _vm.elementDict.customerReserveVoyage.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerReserveVoyage" },
                      slot: "customerReserveVoyage"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerReserveVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerReserveVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "customerReserveVoyage",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.customerReserveVoyage.writable
                        },
                        model: {
                          value: _vm.form.customerReserveVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerReserveVoyage", $$v)
                          },
                          expression: "form.customerReserveVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.na && _vm.elementDict.na.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "na" }, slot: "na" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.na.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.na.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "15",
                              "static-options": _vm.pm.nacList || [],
                              cache: false,
                              "default-value": _vm.form.na,
                              disabled:
                                _vm.readonlyExcludeExportToImport ||
                                !_vm.elementDict.na.writable,
                              filterable: "",
                              clearable: "",
                              "allow-create": true,
                              "tag-name": "nac",
                              "tag-value": "nac",
                              "filter-tag-names": ["nac"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.na = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.naCode && _vm.elementDict.naCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "naCode" }, slot: "naCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.naCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.naCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.naCode.writable,
                          no: "16"
                        },
                        model: {
                          value: _vm.form.naCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "naCode", $$v)
                          },
                          expression: "form.naCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.laneCode && _vm.elementDict.laneCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "laneCode" }, slot: "laneCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.laneCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.laneCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.laneCode.writable,
                          no: "17"
                        },
                        model: {
                          value: _vm.form.laneCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "laneCode", $$v)
                          },
                          expression: "form.laneCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.shippingCompanySpecificCode &&
              _vm.elementDict.shippingCompanySpecificCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "shippingCompanySpecificCode" },
                      slot: "shippingCompanySpecificCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.shippingCompanySpecificCode
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.shippingCompanySpecificCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "shippingCompanySpecificCode",
                        class: _vm.importDifferenceField
                          .shippingCompanySpecificCode
                          ? _vm.fieldClass.shippingCompanySpecificCode +
                            " red-border"
                          : _vm.fieldClass.shippingCompanySpecificCode,
                        attrs: {
                          no: "shippingCompanySpecificCode",
                          "static-options": _vm.shippingCompanySpecificCodeList,
                          cache: false,
                          "default-value": _vm.form.shippingCompanySpecificCode,
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.shippingCompanySpecificCode
                              .writable,
                          filterable: "",
                          clearable: "",
                          "allow-create": true,
                          "tag-name": "shippingCompanySpecificCode",
                          "tag-value": "shippingCompanySpecificCode",
                          "filter-tag-names": ["shippingCompanySpecificCode"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.shippingCompanySpecificCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.subContractNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "subContractNo" }, slot: "subContractNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.subContractNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.subContractNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.subContractNo.writable,
                          no: "18"
                        },
                        model: {
                          value: _vm.form.subContractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "subContractNo", $$v)
                          },
                          expression: "form.subContractNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portDistrict.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "portDistrict" },
                      slot: "portDistrict"
                    },
                    [
                      _c(
                        "div",
                        {
                          class: _vm.elementDict.portDistrict.isRequire
                            ? "blue"
                            : "",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row-reverse",
                            float: "right",
                            width: "100%"
                          },
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "white-space": "nowrap",
                                overflow: "hidden",
                                "text-overflow": "ellipsis"
                              },
                              attrs: {
                                title: _vm.elementDict.portDistrict.label
                              }
                            },
                            [_vm._v(_vm._s(_vm.elementDict.portDistrict.label))]
                          ),
                          _vm.shippingSchedules &&
                          _vm.shippingSchedules.length > 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    disabled:
                                      _vm.readonlyExcludeExportToImport ||
                                      _vm.readonly ||
                                      !_vm.elementDict.portDistrict.writable,
                                    no: "showMoreShippingSchedules",
                                    type: "primary"
                                  },
                                  on: {
                                    click: _vm.showMoreShippingScheduleDialog
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ChooseShippingSchedules"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("el-input", {
                        class: _vm.fieldClass.portDistrict,
                        attrs: {
                          no: "19",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.portDistrict.writable
                        },
                        model: {
                          value: _vm.form.portDistrict,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "portDistrict", $$v)
                          },
                          expression: "form.portDistrict"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.terminalOpendate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "terminalOpendate" },
                      slot: "terminalOpendate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.terminalOpendate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.terminalOpendate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.terminalOpendate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "20",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.terminalOpendate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.terminalOpendate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "terminalOpendate", $$v)
                          },
                          expression: "form.terminalOpendate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.terminalCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "terminalCutoff" },
                      slot: "terminalCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.terminalCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.terminalCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.terminalCutoff,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "21",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.terminalCutoff.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.terminalCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "terminalCutoff", $$v)
                          },
                          expression: "form.terminalCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierCyCutOffTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierCyCutOffTime" },
                      slot: "carrierCyCutOffTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierCyCutOffTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierCyCutOffTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.carrierCyCutOffTime
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "22",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.carrierCyCutOffTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.carrierCyCutOffTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "carrierCyCutOffTime", $$v)
                          },
                          expression: "form.carrierCyCutOffTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.berthPlanDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "berthPlanDate" },
                      slot: "berthPlanDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.berthPlanDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.berthPlanDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.berthPlanDate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "23",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.berthPlanDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.berthPlanDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "berthPlanDate", $$v)
                          },
                          expression: "form.berthPlanDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.unBerthPlanDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "unBerthPlanDate" },
                      slot: "unBerthPlanDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.unBerthPlanDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.unBerthPlanDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.unBerthPlanDate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "24",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.unBerthPlanDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.unBerthPlanDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "unBerthPlanDate", $$v)
                          },
                          expression: "form.unBerthPlanDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.currentETA &&
              _vm.elementDict.currentETA.viewable &&
              _vm.isXycw
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "currentETA" }, slot: "currentETA" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.currentETA.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.currentETA.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.currentETA.writable,
                          no: "103",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.currentETA,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "currentETA", $$v)
                          },
                          expression: "form.currentETA"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.currentETD &&
              _vm.elementDict.currentETD.viewable &&
              _vm.isXycw
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "currentETD" }, slot: "currentETD" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.currentETD.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.currentETD.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.currentETD.writable,
                          no: "104",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.currentETD,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "currentETD", $$v)
                          },
                          expression: "form.currentETD"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualBerthPlanDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualBerthPlanDate" },
                      slot: "actualBerthPlanDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualBerthPlanDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualBerthPlanDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.actualBerthPlanDate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "25",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualBerthPlanDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.actualBerthPlanDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualBerthPlanDate", $$v)
                          },
                          expression: "form.actualBerthPlanDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualUnBerthPlanDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualUnBerthPlanDate" },
                      slot: "actualUnBerthPlanDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualUnBerthPlanDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualUnBerthPlanDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.actualUnBerthPlanDate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "26",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualUnBerthPlanDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        on: { input: _vm.actualUnBerthPlanDateChangeHandler },
                        model: {
                          value: _vm.form.actualUnBerthPlanDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualUnBerthPlanDate", $$v)
                          },
                          expression: "form.actualUnBerthPlanDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.berthPlanPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "berthPlanPlace" },
                      slot: "berthPlanPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.berthPlanPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.berthPlanPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.fieldClass.berthPlanPlace,
                        attrs: {
                          no: "27",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.berthPlanPlace.writable
                        },
                        model: {
                          value: _vm.form.berthPlanPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "berthPlanPlace", $$v)
                          },
                          expression: "form.berthPlanPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualBerthPlanPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "actualBerthPlanPlace" },
                      slot: "actualBerthPlanPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualBerthPlanPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualBerthPlanPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.fieldClass.actualBerthPlanPlace,
                        attrs: {
                          no: "28",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualBerthPlanPlace.writable
                        },
                        model: {
                          value: _vm.form.actualBerthPlanPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualBerthPlanPlace", $$v)
                          },
                          expression: "form.actualBerthPlanPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.realArrivalsDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "realArrivalsDate" },
                      slot: "realArrivalsDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.realArrivalsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.realArrivalsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.fieldClass.realArrivalsDate,
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "29",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.realArrivalsDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.realArrivalsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "realArrivalsDate", $$v)
                          },
                          expression: "form.realArrivalsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.returnPeriodBegin.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "returnPeriodBegin" },
                      slot: "returnPeriodBegin"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.returnPeriodBegin.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.returnPeriodBegin.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.returnPeriodBegin.writable,
                          no: "30",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.returnPeriodBegin,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "returnPeriodBegin", $$v)
                          },
                          expression: "form.returnPeriodBegin"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.returnPeriodEnd.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "returnPeriodEnd" },
                      slot: "returnPeriodEnd"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.returnPeriodEnd.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.returnPeriodEnd.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.returnPeriodEnd.writable,
                          no: "31",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.returnPeriodEnd,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "returnPeriodEnd", $$v)
                          },
                          expression: "form.returnPeriodEnd"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedArrivalTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedArrivalTime" },
                      slot: "estimatedArrivalTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedArrivalTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedArrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "32",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedArrivalTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedArrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                          },
                          expression: "form.estimatedArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualArrivalTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualArrivalTime" },
                      slot: "actualArrivalTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualArrivalTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualArrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "33",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualArrivalTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        on: { input: _vm.actualArrivalTimeChangeHandler },
                        model: {
                          value: _vm.form.actualArrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualArrivalTime", $$v)
                          },
                          expression: "form.actualArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.currentArrivalTime &&
              _vm.elementDict.currentArrivalTime.viewable &&
              _vm.isXycw &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "currentArrivalTime" },
                      slot: "currentArrivalTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.currentArrivalTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.currentArrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "33",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.currentArrivalTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.currentArrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "currentArrivalTime", $$v)
                          },
                          expression: "form.currentArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedPortDischargeTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedPortDischargeTime" },
                      slot: "estimatedPortDischargeTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedPortDischargeTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedPortDischargeTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedPortDischargeTime",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedPortDischargeTime
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedPortDischargeTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedPortDischargeTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedPortDischargeTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portDischargeTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "portDischargeTime" },
                      slot: "portDischargeTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portDischargeTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portDischargeTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "34",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.portDischargeTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.portDischargeTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "portDischargeTime", $$v)
                          },
                          expression: "form.portDischargeTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedRailwayDepartureTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedRailwayDepartureTime" },
                      slot: "estimatedRailwayDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedRailwayDepartureTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedRailwayDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedRailwayDepartureTime",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedRailwayDepartureTime
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedRailwayDepartureTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedRailwayDepartureTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedRailwayDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.railwayDepartureTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "railwayDepartureTime" },
                      slot: "railwayDepartureTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.railwayDepartureTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.railwayDepartureTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "35",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.railwayDepartureTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.railwayDepartureTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "railwayDepartureTime", $$v)
                          },
                          expression: "form.railwayDepartureTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedRailwayDischargeTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedRailwayDischargeTime" },
                      slot: "estimatedRailwayDischargeTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedRailwayDischargeTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedRailwayDischargeTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedRailwayDischargeTime",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedRailwayDischargeTime
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedRailwayDischargeTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedRailwayDischargeTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedRailwayDischargeTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.railwayDischargeTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "railwayDischargeTime" },
                      slot: "railwayDischargeTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.railwayDischargeTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.railwayDischargeTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "36",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.railwayDischargeTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.railwayDischargeTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "railwayDischargeTime", $$v)
                          },
                          expression: "form.railwayDischargeTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedArrivalPlaceOfDelivery.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedArrivalPlaceOfDelivery" },
                      slot: "estimatedArrivalPlaceOfDelivery"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedArrivalPlaceOfDelivery
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedArrivalPlaceOfDelivery
                              .label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedArrivalPlaceOfDelivery",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedArrivalPlaceOfDelivery
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedArrivalPlaceOfDelivery,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedArrivalPlaceOfDelivery",
                              $$v
                            )
                          },
                          expression: "form.estimatedArrivalPlaceOfDelivery"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualArrivalPlaceOfDelivery.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "actualArrivalPlaceOfDelivery" },
                      slot: "actualArrivalPlaceOfDelivery"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualArrivalPlaceOfDelivery
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.actualArrivalPlaceOfDelivery.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "actualArrivalPlaceOfDelivery",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualArrivalPlaceOfDelivery
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.actualArrivalPlaceOfDelivery,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "actualArrivalPlaceOfDelivery",
                              $$v
                            )
                          },
                          expression: "form.actualArrivalPlaceOfDelivery"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedCustomsReleaseTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedCustomsReleaseTime" },
                      slot: "estimatedCustomsReleaseTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedCustomsReleaseTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedCustomsReleaseTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "37",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedCustomsReleaseTime
                              .writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedCustomsReleaseTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedCustomsReleaseTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedCustomsReleaseTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destPortCustomsClearanceTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "destPortCustomsClearanceTime" },
                      slot: "destPortCustomsClearanceTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destPortCustomsClearanceTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.destPortCustomsClearanceTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "38",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.destPortCustomsClearanceTime
                              .writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.destPortCustomsClearanceTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "destPortCustomsClearanceTime",
                              $$v
                            )
                          },
                          expression: "form.destPortCustomsClearanceTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "destPortInspection" },
                      slot: "destPortInspection"
                    },
                    [
                      _c("line-label", {
                        attrs: {
                          slot: "label",
                          label: _vm.$t("SeaExport.DestinationPortInspection")
                        },
                        slot: "label"
                      }),
                      _c("el-switch", {
                        attrs: {
                          no: "38-1",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid)
                        },
                        model: {
                          value: _vm.form.destPortInspection,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destPortInspection", $$v)
                          },
                          expression: "form.destPortInspection"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "destPortInspectionLevel" },
                      slot: "destPortInspectionLevel"
                    },
                    [
                      _c("line-label", {
                        attrs: {
                          slot: "label",
                          label: _vm.$t(
                            "SeaExport.DestinationPortInspectionLevel"
                          )
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "38-2",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid)
                        },
                        model: {
                          value: _vm.form.destPortInspectionLevel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destPortInspectionLevel", $$v)
                          },
                          expression: "form.destPortInspectionLevel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedPickUpTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: {
                        slot: "estimatedPickUpTime",
                        title: _vm.elementDict.estimatedPickUpTime.label
                      },
                      slot: "estimatedPickUpTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedPickUpTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedPickUpTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "39",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.estimatedPickUpTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedPickUpTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedPickUpTime", $$v)
                          },
                          expression: "form.estimatedPickUpTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actualPickUpTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: {
                        slot: "actualPickUpTime",
                        title: _vm.elementDict.actualPickUpTime.label
                      },
                      slot: "actualPickUpTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actualPickUpTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actualPickUpTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "40",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.actualPickUpTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.actualPickUpTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actualPickUpTime", $$v)
                          },
                          expression: "form.actualPickUpTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDeliveryToWarehouseTime.viewable &&
              _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "estimatedDeliveryToWarehouseTime",
                        title:
                          _vm.elementDict.estimatedDeliveryToWarehouseTime.label
                      },
                      slot: "estimatedDeliveryToWarehouseTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedDeliveryToWarehouseTime
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedDeliveryToWarehouseTime
                              .label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.estimatedDeliveryToWarehouseTime
                              .writable,
                          no: "41",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedDeliveryToWarehouseTime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "estimatedDeliveryToWarehouseTime",
                              $$v
                            )
                          },
                          expression: "form.estimatedDeliveryToWarehouseTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.deliveryTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "deliveryTime",
                        title: _vm.elementDict.deliveryTime.label
                      },
                      slot: "deliveryTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.deliveryTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.deliveryTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.deliveryTime.writable,
                          no: "42",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.deliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "deliveryTime", $$v)
                          },
                          expression: "form.deliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destPortDeliveryTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "destPortDeliveryTime",
                        title: _vm.elementDict.destPortDeliveryTime.label
                      },
                      slot: "destPortDeliveryTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destPortDeliveryTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destPortDeliveryTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.destPortDeliveryTime.writable,
                          no: "43",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.destPortDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destPortDeliveryTime", $$v)
                          },
                          expression: "form.destPortDeliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.deliveryCompletionDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "deliveryCompletionDate",
                        title: _vm.elementDict.deliveryCompletionDate.label
                      },
                      slot: "deliveryCompletionDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.deliveryCompletionDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.deliveryCompletionDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.deliveryCompletionDate.writable,
                          no: "44",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.deliveryCompletionDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "deliveryCompletionDate", $$v)
                          },
                          expression: "form.deliveryCompletionDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EstimatedDeliveryTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "41",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estDeliveryTime", $$v)
                          },
                          expression: "form.estDeliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ActualDeliveryTime") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "42",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.actDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "actDeliveryTime", $$v)
                          },
                          expression: "form.actDeliveryTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedReturnTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "estimatedReturnTime" },
                      slot: "estimatedReturnTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedReturnTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedReturnTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "45",
                          type: "datetime",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.estimatedReturnTime.writable,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedReturnTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedReturnTime", $$v)
                          },
                          expression: "form.estimatedReturnTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destPortReturnTime.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "destPortReturnTime" },
                      slot: "destPortReturnTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destPortReturnTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destPortReturnTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "46",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            Boolean(_vm.form.lclMasterUuid) ||
                            !_vm.elementDict.destPortReturnTime.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.destPortReturnTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destPortReturnTime", $$v)
                          },
                          expression: "form.destPortReturnTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.yardCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "yardCode" }, slot: "yardCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.yardCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.yardCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.yardCode.writable,
                          no: "47"
                        },
                        model: {
                          value: _vm.form.yardCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "yardCode", $$v)
                          },
                          expression: "form.yardCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "portCode" }, slot: "portCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.portCode
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.portCode.writable,
                          no: "48"
                        },
                        model: {
                          value: _vm.form.portCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "portCode", $$v)
                          },
                          expression: "form.portCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.addressEIR.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "addressEIR" }, slot: "addressEIR" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.addressEIR.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.addressEIR.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.addressEIR.writable,
                          type: "textarea",
                          rows: 3,
                          no: "49"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EquipmentReceiptAddress"),
                              _vm.form.addressEIR,
                              function(val) {
                                _vm.form.addressEIR = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.addressEIR,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "addressEIR", $$v)
                          },
                          expression: "form.addressEIR"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.contactEIR.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "contactEIR" }, slot: "contactEIR" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.contactEIR.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.contactEIR.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.contactEIR.writable,
                          no: "50"
                        },
                        model: {
                          value: _vm.form.contactEIR,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contactEIR", $$v)
                          },
                          expression: "form.contactEIR"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.phoneEIR.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "phoneEIR" }, slot: "phoneEIR" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.phoneEIR.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.phoneEIR.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.phoneEIR.writable,
                          no: "51"
                        },
                        model: {
                          value: _vm.form.phoneEIR,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phoneEIR", $$v)
                          },
                          expression: "form.phoneEIR"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.fileCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "fileCutoff" }, slot: "fileCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.fileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.fileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.fileCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.fileCutoff.writable,
                          no: "52",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fileCutoff", $$v)
                          },
                          expression: "form.fileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.declareCutOff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "declareCutOff" }, slot: "declareCutOff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.declareCutOff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.declareCutOff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.declareCutOff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.declareCutOff.writable,
                          no: "53",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.declareCutOff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "declareCutOff", $$v)
                          },
                          expression: "form.declareCutOff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customCutoff" }, slot: "customCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.customCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.customCutoff.writable,
                          no: "54",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.customCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customCutoff", $$v)
                          },
                          expression: "form.customCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerCutoff" },
                      slot: "customerCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.customerCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.customerCutoff.writable,
                          no: "55",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.customerCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerCutoff", $$v)
                          },
                          expression: "form.customerCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerShutout.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerShutout" },
                      slot: "customerShutout"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerShutout.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerShutout.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.customerShutout.writable,
                          no: "56",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.customerShutout,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerShutout", $$v)
                          },
                          expression: "form.customerShutout"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerFileCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerFileCutoff" },
                      slot: "customerFileCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerFileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerFileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.customerFileCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.customerFileCutoff.writable,
                          no: "56",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.customerFileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customerFileCutoff", $$v)
                          },
                          expression: "form.customerFileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.amsCutoff.viewable && _vm.form.ams
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "amsCutoff" }, slot: "amsCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.amsCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.amsCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.amsCutoff.writable,
                          no: "57",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.amsCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "amsCutoff", $$v)
                          },
                          expression: "form.amsCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.apCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "apCode" }, slot: "apCode" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.apCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.apCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.apCode
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.apCode.writable,
                          no: "58"
                        },
                        model: {
                          value: _vm.form.apCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "apCode", $$v)
                          },
                          expression: "form.apCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.apName.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "apName" }, slot: "apName" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.apName.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.apName.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.apName
                          ? "red-border"
                          : "",
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.apName.writable,
                          no: "59"
                        },
                        model: {
                          value: _vm.form.apName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "apName", $$v)
                          },
                          expression: "form.apName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.freeTime.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "freeTime" }, slot: "freeTime" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freeTime.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freeTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-input-number", {
                        staticClass: "align-left",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.freeTime.writable,
                          no: "60",
                          controls: false
                        },
                        model: {
                          value: _vm.form.freeTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeTime", $$v)
                          },
                          expression: "form.freeTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedPackDate.viewable && _vm.showButton
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "estimatedPackDate" },
                      slot: "estimatedPackDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.estimatedPackDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.estimatedPackDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.estimatedPackDate.writable,
                          no: "61",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.estimatedPackDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "estimatedPackDate", $$v)
                          },
                          expression: "form.estimatedPackDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.arrivalTime.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "arrivalTime" }, slot: "arrivalTime" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.arrivalTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.arrivalTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.arrivalTime.writable,
                          no: "62",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.arrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "arrivalTime", $$v)
                          },
                          expression: "form.arrivalTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.textEntrustmentState.viewable &&
              _vm.showEntrustmentState
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "textEntrustmentState" },
                      slot: "textEntrustmentState"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.textEntrustmentState.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.textEntrustmentState.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "155px" },
                        attrs: {
                          disabled: true,
                          value: _vm.textEntrustmentState
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.pm.entrustHisBtnClickHandler()
                          }
                        }
                      }),
                      _c(
                        "cargo-button-container",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "2px" },
                              attrs: {
                                disabled:
                                  _vm.readonlyExcludeExportToImport ||
                                  !_vm.elementDict.textEntrustmentState
                                    .writable,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.entrustHisBtnClickHandler()
                                }
                              }
                            },
                            [_vm._v("...")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondVesselVoyage.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "secondVesselVoyage" },
                      slot: "secondVesselVoyage"
                    },
                    [
                      _c("line-label", {
                        class: _vm.fieldClass.secondVesselVoyageTitle
                          ? _vm.fieldClass.secondVesselVoyageTitle
                          : _vm.elementDict.secondVesselVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondVesselVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.fieldClass.secondVesselVoyage,
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.secondVesselVoyage.writable,
                          no: "63"
                        },
                        model: {
                          value: _vm.form.secondVesselVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondVesselVoyage", $$v)
                          },
                          expression: "form.secondVesselVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondVoyage.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "secondVoyage" }, slot: "secondVoyage" },
                    [
                      _c("line-label", {
                        class: _vm.fieldClass.secondVoyageTitle
                          ? _vm.fieldClass.secondVoyageTitle
                          : _vm.elementDict.secondVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        class: _vm.fieldClass.secondVoyage,
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.secondVoyage.writable,
                          no: "64"
                        },
                        model: {
                          value: _vm.form.secondVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondVoyage", $$v)
                          },
                          expression: "form.secondVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondVesselETD.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "secondVesselETD" },
                      slot: "secondVesselETD"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondVesselETD.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondVesselETD.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.secondVesselETD.writable,
                          no: "65",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.secondVesselETDChange },
                        model: {
                          value: _vm.form.secondVesselETD,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondVesselETD", $$v)
                          },
                          expression: "form.secondVesselETD"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.secondPolCode.viewable,
                      expression: "elementDict.secondPolCode.viewable"
                    }
                  ],
                  attrs: { slot: "secondPolCode" },
                  slot: "secondPolCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondPolCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondPolCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondPolCode",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "secondPolCode",
                      disabled:
                        _vm.readonlyExcludeExportToImport ||
                        !_vm.elementDict.secondPolCode.writable,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.secondPolCode,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondPolCode = p.value
                        _vm.form.secondPol = p.englishName
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.secondPol.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "secondPol" }, slot: "secondPol" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondPol.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondPol.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.secondPol.writable,
                          no: "secondPol"
                        },
                        model: {
                          value: _vm.form.secondPol,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondPol", $$v)
                          },
                          expression: "form.secondPol"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.secondPodCode.viewable,
                      expression: "elementDict.secondPodCode.viewable"
                    }
                  ],
                  attrs: { slot: "secondPodCode" },
                  slot: "secondPodCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondPodCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondPodCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondPodCode",
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "secondPodCode",
                      disabled:
                        _vm.readonlyExcludeExportToImport ||
                        !_vm.elementDict.secondPodCode.writable,
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.secondPodCode,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondPodCode = p.value
                        _vm.form.secondPod = p.englishName
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.secondPod.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "secondPod" }, slot: "secondPod" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondPod.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondPod.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.secondPod.writable,
                          no: "secondPod"
                        },
                        model: {
                          value: _vm.form.secondPod,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondPod", $$v)
                          },
                          expression: "form.secondPod"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondArrivalsDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondArrivalsDate" },
                      slot: "secondArrivalsDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondArrivalsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondArrivalsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "secondArrivalsDate",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.secondArrivalsDate.writable,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.secondArrivalsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondArrivalsDate", $$v)
                          },
                          expression: "form.secondArrivalsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondUnloadingDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondUnloadingDate" },
                      slot: "secondUnloadingDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondUnloadingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondUnloadingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "secondUnloadingDate",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.secondUnloadingDate.writable,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.secondUnloadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondUnloadingDate", $$v)
                          },
                          expression: "form.secondUnloadingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondLoadingDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondLoadingDate" },
                      slot: "secondLoadingDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondLoadingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondLoadingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "secondLoadingDate",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.secondLoadingDate.writable,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.secondLoadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondLoadingDate", $$v)
                          },
                          expression: "form.secondLoadingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondShipmentDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "secondShipmentDate" },
                      slot: "secondShipmentDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondShipmentDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondShipmentDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "secondShipmentDate",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.secondShipmentDate.writable,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.secondShipmentDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondShipmentDate", $$v)
                          },
                          expression: "form.secondShipmentDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.fnlTm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "fnlTm" }, slot: "fnlTm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.fnlTm.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.fnlTm.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "cargo-multi-select",
                        {
                          attrs: {
                            no: "66",
                            disabled:
                              _vm.readonlyExcludeExportToImport ||
                              !_vm.elementDict.fnlTm
                          },
                          model: {
                            value: _vm.form.fnlTm,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fnlTm", $$v)
                            },
                            expression: "form.fnlTm"
                          }
                        },
                        _vm._l(_vm.FNL_TM, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.englishName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeETD.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "bargeETD" },
                      slot: "bargeETD"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeETD.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeETD.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.bargeETD.writable,
                          no: "67",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.bargeETD,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeETD", $$v)
                          },
                          expression: "form.bargeETD"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeETA.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "warn-label",
                      attrs: { slot: "bargeETA" },
                      slot: "bargeETA"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeETA.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeETA.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            _vm.editPermissions ||
                            !_vm.elementDict.bargeETA.writable,
                          no: "68",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.bargeETA,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeETA", $$v)
                          },
                          expression: "form.bargeETA"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeVessel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bargeVessel" }, slot: "bargeVessel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeVessel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeVessel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargeVessel.writable,
                          no: "69"
                        },
                        model: {
                          value: _vm.form.bargeVessel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeVessel", $$v)
                          },
                          expression: "form.bargeVessel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeVoyage.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bargeVoyage" }, slot: "bargeVoyage" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargeVoyage.writable,
                          no: "70"
                        },
                        on: {
                          focus: function($event) {
                            _vm.form.bargeVoyage = _vm.form.bargeVoyage || "V."
                          }
                        },
                        model: {
                          value: _vm.form.bargeVoyage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeVoyage", $$v)
                          },
                          expression: "form.bargeVoyage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargePOL.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bargePOL" }, slot: "bargePOL" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargePOL.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargePOL.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargePOL.writable,
                          no: "71"
                        },
                        model: {
                          value: _vm.form.bargePOL,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargePOL", $$v)
                          },
                          expression: "form.bargePOL"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargePOD.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bargePOD" }, slot: "bargePOD" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargePOD.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargePOD.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargePOD.writable,
                          no: "72"
                        },
                        model: {
                          value: _vm.form.bargePOD,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargePOD", $$v)
                          },
                          expression: "form.bargePOD"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.vesselLineCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "vesselLineCode" },
                      slot: "vesselLineCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.vesselLineCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.vesselLineCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.vesselLineCode.writable,
                          no: "73"
                        },
                        model: {
                          value: _vm.form.vesselLineCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "vesselLineCode", $$v)
                          },
                          expression: "form.vesselLineCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeCustomCutoff.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "bargeCustomCutoff" },
                      slot: "bargeCustomCutoff"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeCustomCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeCustomCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargeCustomCutoff.writable,
                          no: "74",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.form.bargeCustomCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeCustomCutoff", $$v)
                          },
                          expression: "form.bargeCustomCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.riverCarrierId.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "riverCarrierId" },
                      slot: "riverCarrierId"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.riverCarrierId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.riverCarrierId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "75",
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.riverCarrierId.writable,
                          "method-params": { seaCmp: true },
                          "default-value": _vm.form.riverCarrierId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.riverCarrierId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bargeRemarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bargeRemarks" }, slot: "bargeRemarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeRemarks.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeRemarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.bargeRemarks.writable,
                          no: "bargeRemarks",
                          type: "textarea",
                          rows: 2
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.form.bargeRemarks,
                              function(val) {
                                _vm.form.bargeRemarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.bargeRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bargeRemarks", $$v)
                          },
                          expression: "form.bargeRemarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.enableShipperConsignNotify,
                      expression: "enableShipperConsignNotify"
                    }
                  ],
                  staticClass: "section form-column",
                  attrs: { slot: "shipperConsignNotify" },
                  slot: "shipperConsignNotify"
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonlyExcludeExportToImport,
                        "label-width": "70px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                          )
                        )
                      ]),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "shipperCode",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.enableShipperLocked,
                                no: "shipperCode"
                              },
                              model: {
                                value: _vm.mblCargoDoc.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblCargoDoc, "shipperCode", $$v)
                                },
                                expression: "mblCargoDoc.shipperCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "shipperId",
                                disabled: _vm.enableShipperLocked,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                filterable: "",
                                "default-value": _vm.mblCargoDoc.shipperId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.shipperAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "reset",
                                  disabled: _vm.enableShipperLocked,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "shipperLine" + count,
                            staticClass: "auto-width"
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck["shipperLine" + count]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "shipperLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled: _vm.enableShipperLocked,
                                    no: "shipperLine" + count,
                                    "auto-uppercase": _vm.isUppercase
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.mblCargoDoc,
                                        "shipperLine" + count,
                                        count + 1 > 7
                                          ? null
                                          : "shipperLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showShipperDialog($event)
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.mblCargoDoc["shipperLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "shipperLine" + count,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mblCargoDoc['shipperLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "consigneeCode",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.enableShipperLocked,
                                no: "19"
                              },
                              model: {
                                value: _vm.mblCargoDoc.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mblCargoDoc,
                                    "consigneeCode",
                                    $$v
                                  )
                                },
                                expression: "mblCargoDoc.consigneeCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "consigneeId",
                                disabled: _vm.enableShipperLocked,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  consignee: true,
                                  active: true
                                },
                                filterable: "",
                                "default-value":
                                  _vm.mblCargoDoc.consigneeId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.consigneeAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "reset",
                                  type: "primary",
                                  disabled: _vm.enableShipperLocked
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(2)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "consigneeLine" + count,
                            staticClass: "auto-width"
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck[
                                      "consigneeLine" + count
                                    ]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "consigneeLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    disabled: _vm.enableShipperLocked,
                                    no: "consigneeLine" + count,
                                    "auto-uppercase": _vm.isUppercase
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.mblCargoDoc,
                                        "consigneeLine" + count,
                                        count + 1 > 7
                                          ? null
                                          : "consigneeLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showConsigneeDialog($event)
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.mblCargoDoc["consigneeLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "consigneeLine" + count,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mblCargoDoc['consigneeLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))]
                        ),
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "notifyCode",
                              attrs: {
                                disabled: _vm.enableShipperLocked,
                                no: "notifyCode"
                              },
                              model: {
                                value: _vm.mblCargoDoc.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.mblCargoDoc, "notifyCode", $$v)
                                },
                                expression: "mblCargoDoc.notifyCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              attrs: {
                                no: "notifyId",
                                disabled: _vm.enableShipperLocked,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { notify: true, active: true },
                                filterable: "",
                                "default-value": _vm.mblCargoDoc.notifyId || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.notifyAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "reset",
                                      type: "primary",
                                      disabled: _vm.enableShipperLocked
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(3)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Reset")) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "copyConsignee",
                                      type: "primary",
                                      disabled: _vm.enableShipperLocked
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onCopyConsignee()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CopyTheConsignee")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "notifyLine" + count,
                            staticClass: "auto-width"
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck["notifyLine" + count]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "notifyLine" + count,
                                  refInFor: true,
                                  attrs: {
                                    no: "notifyLine" + count,
                                    disabled: _vm.enableShipperLocked,
                                    "auto-uppercase": _vm.isUppercase
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.mblCargoDoc,
                                        "notifyLine" + count,
                                        count + 1 > 7
                                          ? null
                                          : "notifyLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showNotifyDialog($event)
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.mblCargoDoc["notifyLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mblCargoDoc,
                                        "notifyLine" + count,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "mblCargoDoc['notifyLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.elementDict.remarksShipping.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "remarksShipping" },
                      slot: "remarksShipping"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarksShipping.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarksShipping.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "395px" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.remarksShipping.writable,
                          no: "76",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ShippingAdviceRemark"),
                              _vm.form.remarksShipping,
                              function(val) {
                                _vm.form.remarksShipping = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarksShipping,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarksShipping", $$v)
                          },
                          expression: "form.remarksShipping"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarksBooking.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "remarksBooking" },
                      slot: "remarksBooking"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarksBooking.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarksBooking.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "395px" },
                        attrs: {
                          disabled:
                            _vm.readonlyExcludeExportToImport ||
                            !_vm.elementDict.remarksBooking.writable,
                          no: "77",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.BookingConfirmationRemarks"),
                              _vm.form.remarksBooking,
                              function(val) {
                                _vm.form.remarksBooking = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarksBooking,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarksBooking", $$v)
                          },
                          expression: "form.remarksBooking"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isTP
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { width: "100%" },
                      attrs: { slot: "ediReceipt" },
                      slot: "ediReceipt"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_MultiLegVoyageManagement")
                          )
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "form-row",
                          staticStyle: { "flex-direction": "row" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "padding-bottom": "5px"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "add",
                                    type: "primary",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.addClickHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "delete",
                                    type: "danger",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.deleteClickHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            attrs: {
                              "show-side-bar": false,
                              "grid-options": _vm.leg.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "grid-style": "height:100%;",
                              "row-data": _vm.leg.rowData
                            },
                            on: {
                              gridReady: function(params) {
                                return (_vm.leg.gridApi = params.api)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.ediReceipt.showEdiReceipt
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      attrs: { slot: "ediReceipt" },
                      slot: "ediReceipt"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.BookingReceipt")) +
                            " (" +
                            _vm._s(_vm.$t("SeaExport.InMailOfThePrevail")) +
                            ")"
                        )
                      ]),
                      _c("booking-confirmation", {
                        attrs: {
                          "edi-receipt-data": _vm.ediReceipt.data,
                          "job-no": _vm.pm.job.jobNo
                        },
                        on: { syncBC: _vm.syncBC }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ediReceiptCommon.showEdiReceipt
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      attrs: { slot: "ediReceiptCommon" },
                      slot: "ediReceiptCommon"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.BookingReceipt")))
                      ]),
                      _c("booking-confirmation-common", {
                        attrs: {
                          "edi-receipt-data": _vm.ediReceiptCommon.data,
                          "job-no": _vm.pm.job.jobNo,
                          job: _vm.pm.job,
                          "last-receipt-time": _vm.ediReceiptCommon.data[0].time
                        },
                        on: {
                          showYdBookingResult: function($event) {
                            return _vm.$emit(
                              "showYdBookingResult",
                              "tabVesselEq"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c("input", {
            ref: "importFile",
            staticStyle: { display: "none" },
            attrs: { type: "file", accept: ".pms" },
            on: { change: _vm.onImportFile }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.readonlyExcludeExportToImport,
                  type: "textarea",
                  rows: "10"
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditExcludeExportToImport,
                          expression: "isEditExcludeExportToImport"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.transAdvanceTextDialog.visible,
                title: _vm.transAdvanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transAdvanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: {
                  disabled:
                    _vm.readonlyExcludeExportToImport ||
                    _vm.enableShipperLocked,
                  type: "textarea",
                  rows: "10"
                },
                model: {
                  value: _vm.transAdvanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.transAdvanceTextDialog, "value", $$v)
                  },
                  expression: "transAdvanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEditExcludeExportToImport,
                          expression: "isEditExcludeExportToImport"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishTransAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.transAdvanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("SeaExport.tips"),
                visible: _vm.vesseldialog,
                width: "30%",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.vesseldialog = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-indent": "2em",
                    "font-size": "14px",
                    "line-height": "1.5",
                    "letter-spacing": "0.5px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.ObtainedContainerAndGoodsData")) +
                      " "
                  ),
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-size": "14px" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.ShipName")) +
                          _vm._s(
                            _vm.jobDataVessel
                              ? _vm.jobDataVessel
                              : _vm.$t("SeaExport.empty")
                          ) +
                          "、" +
                          _vm._s(_vm.$t("SeaExport.Sailing")) +
                          _vm._s(
                            _vm.jobDataVoyageFlight
                              ? _vm.jobDataVoyageFlight
                              : _vm.$t("SeaExport.empty")
                          )
                      )
                    ]
                  ),
                  _vm._v(_vm._s(_vm.$t("SeaExport.WithBookingTab")) + " "),
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-size": "14px" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Message.ShipName")) +
                          _vm._s(
                            _vm.shippingDate.vessel
                              ? _vm.shippingDate.vessel
                              : _vm.$t("SeaExport.empty")
                          ) +
                          "、" +
                          _vm._s(_vm.$t("SeaExport.Sailing")) +
                          _vm._s(
                            _vm.shippingDate.voyageFlight
                              ? _vm.shippingDate.voyageFlight
                              : _vm.$t("SeaExport.empty")
                          )
                      )
                    ]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("SeaExport.InconsistentFromTheBillData")) +
                      " "
                  ),
                  _c("br"),
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("SeaExport.InconsistentFromTheBillDataTips")
                      )
                    )
                  ])
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("empty")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importEmpty")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("notEmpty")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.importNotEmpty")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.changeVessel("ignore")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ignore")))]
                  )
                ],
                1
              )
            ]
          ),
          _c("cross-tenant-history-dialog", {
            attrs: {
              visible: _vm.crossTenantHistoryDialog.visible,
              "entrustment-type": _vm.crossTenantHistoryDialog.entrustmentType,
              "job-no": _vm.crossTenantHistoryDialog.jobNo
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.crossTenantHistoryDialog, "visible", $event)
              }
            }
          }),
          _c("api-popup", {
            attrs: {
              visible: _vm.apiPopup.visible,
              title: _vm.apiPopup.title,
              "interface-type": _vm.apiPopup.interfaceType,
              "interface-array": _vm.apiPopup.interfaceArray
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.apiPopup, "visible", $event)
              },
              selectedApi: _vm.selectedApiCallback
            }
          }),
          _c("error-log-dialog", {
            attrs: {
              visible: _vm.errorLogDialog.visible,
              "error-log": _vm.errorLogDialog.errorLog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.errorLogDialog, "visible", $event)
              }
            }
          }),
          _c("dialog-selector", {
            attrs: {
              visible: _vm.selectorDialog.visible,
              title: _vm.selectorDialog.title,
              "row-data": _vm.selectorDialog.rowData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectorDialog, "visible", $event)
              },
              selected: _vm.getEDICallback
            }
          }),
          _c("message-preview-dialog", {
            attrs: {
              visible: _vm.messagePreviewDialog.visible,
              params: _vm.messagePreviewDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
              }
            }
          }),
          _c("multi-seg-num-rules-dialog", {
            attrs: { visible: _vm.multiSegNumRulesDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.multiSegNumRulesDialog, "visible", $event)
              },
              callback: _vm.multiSegNumRulesCallback
            }
          }),
          _c("generate-mbl-no-dialog", {
            attrs: {
              visible: _vm.mblConfig.visible,
              form: _vm.form,
              config: _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.mblConfig.visible = false
              }
            }
          }),
          _c("generate-so-no-dialog", {
            attrs: {
              visible: _vm.soNoConfig.visible,
              form: _vm.form,
              config: _vm.soNoConfig,
              "input-mbl": _vm.isInputMbl,
              "mbl-config": _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.soNoConfig.visible = false
              }
            }
          }),
          _vm.ediBaseWindow.visible
            ? _c("edi-guide-window", {
                ref: "ediBaseWindow",
                attrs: {
                  "do-saving": _vm.doSaving,
                  "global-var": _vm.globalVar,
                  visible: _vm.ediBaseWindow.visible,
                  "call-back-func": _vm.ediBaseWindow.callBackFunc,
                  context: _vm.context
                },
                on: {
                  close: function($event) {
                    _vm.ediBaseWindow.visible = false
                  },
                  ediChangeHandler: _vm.ediChangeHandler
                }
              })
            : _vm._e(),
          _vm.bookingLogDialog.visible
            ? _c("booking-log-dialog", {
                attrs: {
                  visible: _vm.bookingLogDialog.visible,
                  "job-uuid": _vm.bookingLogDialog.jobUuid,
                  "send-type": _vm.bookingLogDialog.sendType
                },
                on: {
                  close: function($event) {
                    _vm.bookingLogDialog.visible = false
                  }
                }
              })
            : _vm._e(),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.subscriptionStatusDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_BookingSubscriptionStatus"),
                width: "700px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.subscriptionStatusDialog,
                    "visible",
                    $event
                  )
                }
              }
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.subscriptionStatusDialog.loading,
                      expression: "subscriptionStatusDialog.loading"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.subscriptionStatusDialog.list,
                    size: "mini",
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "dataTypeName",
                      label: _vm.$t("CargoMsg.Cargo_SubscribeDataType"),
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "subscribeStatusName",
                      label: _vm.$t("CargoMsg.Cargo_SubscribeStatus"),
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "failReason",
                      label: _vm.$t("CargoMsg.Cargo_ResultMessage"),
                      "min-width": "200"
                    }
                  })
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.subscriptionStatusDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.showMoreShippingSchedule
            ? _c("choose-shipping-schedules", {
                attrs: {
                  visible: _vm.showMoreShippingSchedule,
                  job: _vm.form,
                  "shipping-schedules": _vm.shippingSchedules,
                  "choose-shipping-schedule": _vm.chooseShippingSchedule,
                  "is-btn": _vm.isChooseShippingScheduleBtn
                },
                on: { close: _vm.closeMoreShippingScheduleDialog }
              })
            : _vm._e(),
          _c("shipping-schedule-dialog", {
            ref: "voyageShowDialog",
            attrs: {
              visible: _vm.voyageShowDialog,
              callback: _vm.callbackShippingScheduleHanle
            },
            on: {
              "update:visible": function($event) {
                _vm.voyageShowDialog = $event
              }
            }
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showRouteDialog,
                title: this.$t("common.btn.confirm"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.showRouteDialog = $event
                }
              }
            },
            [
              _c("div", { staticStyle: { "margin-bottom": "16px" } }, [
                _vm._v(_vm._s(this.routeTitle))
              ]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.selectedRoute,
                    callback: function($$v) {
                      _vm.selectedRoute = $$v
                    },
                    expression: "selectedRoute"
                  }
                },
                _vm._l(_vm.routeOptions, function(item) {
                  return _c("el-radio", { key: item, attrs: { label: item } }, [
                    _vm._v(_vm._s(item))
                  ])
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onRouteDialogConfirm }
                    },
                    [_vm._v(_vm._s(this.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.showRouteDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(this.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }